export default "__VITE_ASSET__DKxcWr6m__"